import { render, staticRenderFns } from "./bwordlist.vue?vue&type=template&id=1692b2f5&scoped=true&"
import script from "./bwordlist.vue?vue&type=script&lang=js&"
export * from "./bwordlist.vue?vue&type=script&lang=js&"
import style0 from "./bwordlist.vue?vue&type=style&index=0&id=1692b2f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1692b2f5",
  null
  
)

export default component.exports